/**
 * Created by fengc on 2020/03/16.
 */
import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { StyleSheet, View, Text, TouchableWithoutFeedback, Platform } from "react-native";
import Icon from "react-native-vector-icons/Ionicons";
import Letter from "./Letter";
import { GetWordContainerStyleBySentenceCommand, GetWordStyleBySentenceCommand, EnumHasFlag } from "../../utils/MarkTextHelper";
import { BottomPopExplanationInstance } from "./BottomPopExplanation";
import Constants from "../../config/Constants";
import Typo from "./typo";
import Syllable from "./Syllable";
import * as Helper from "../../utils/Helper";

//const customFontName = Platform.OS === "ios" ? "SourceHanSansCN-Regular" : "sourcehansansCN";
class Word extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        //let letterStyle = { ...this.props.letterStyle, fontFamily: customFontName };
        //let pinyinStyle = { ...styles.pinyin, fontFamily: customFontName }
        let letterStyle = { ...this.props.letterStyle, };
        let pinyinStyle = { ...styles.pinyin, ...this.props.syllableStyle };

        for (var key in this.props.style) {
            if (!(key === "color" || key.indexOf("font") !== -1 || key === "lineHeight")) {
                continue;
            }

            // if this 'font' property is undefined in letterStyle, it will be added to letterStyle!
            if (!letterStyle[key]) {
                letterStyle[key] = this.props.style[key];
                pinyinStyle[key] = key === "fontSize" ? this.props.style[key] * 0.618 : this.props.style[key];
            }
        }
        let containerStyle = [styles.container];
        if (this.props.style) {
            containerStyle.push(this.props.style);
        }

        if (this.props.wrapLetters) {
            containerStyle.push({ flexWrap: "wrap" })
        }

        let { chars, syllables, command } = this.props.data;
        if (!_.isArray(chars)) {
            chars = _.toArray(chars); // convert it to an array for processing
        }

        //we already has command return
        let style = GetWordStyleBySentenceCommand(command);
        let commandContainerStyle = GetWordContainerStyleBySentenceCommand(command);

        if (EnumHasFlag(command, Constants.TEXT_MARK_TYPE.TYPO)) {
            return (
                <>
                    <TouchableWithoutFeedback onPress={this._handlePress.bind(this, this.props.data)}>
                        <View style={[commandContainerStyle, containerStyle]}>
                            {chars && chars.map((item, i) => {
                                const charCode = item.charCodeAt(0).toString();
                                var exstyle = {};
                                if (this.props.charProgress > 0 && i < this.props.charProgress) {
                                    exstyle.color = this.props.progressColor;
                                }
                                return (
                                    <View>
                                        {this.props.pinyinVisible && (
                                            <View style={{ marginHorizontal: 1 }}>
                                                <Syllable style={[pinyinStyle, letterStyle, exstyle]} data={this.props.data.syllables[i]} />
                                            </View>
                                        )}
                                        <View style={{ marginHorizontal: 1 }}>
                                            <Typo
                                                key={i}
                                                name={charCode}
                                                style={[styles.typo, letterStyle, exstyle]}
                                            />
                                        </View>
                                    </View>
                                );
                            })}
                        </View>
                    </TouchableWithoutFeedback>
                </>
            );
        }

        let icon = null;
        if(this.props.iconKind === "yes"){
            icon = <Icon name="ios-checkmark-circle" size={12} style={[styles.iconRight]} />
        }else if(this.props.iconKind === "no"){
            icon = <Icon name="ios-close-circle" size={12} style={[styles.iconWrong]} />
        }

        return (
            <>
                <TouchableWithoutFeedback onPress={this._handlePress.bind(this, this.props.data)}>
                    <View style={[commandContainerStyle, containerStyle]}>
                        {icon}
                        {(this.props.language !== 'zh') ?
                         (<Text style={{ ...style, ...letterStyle }}>{chars ? chars.join("") : ""}</Text>) : null}
                        {chars && (this.props.language === 'zh') &&
                            syllables &&
                            chars.map((item, i) => {
                                var exstyle = {};
                                if (this.props.charProgress > 0 && i < this.props.charProgress) {
                                    exstyle.color = this.props.progressColor;
                                }
                                if (this.props.overriddenLetters && this.props.overriddenLetters.letters && this.props.overriddenLetters.renderOverriddenLetter) {
                                    for (let j = 0; j < this.props.overriddenLetters.letters.length; j++) {
                                        // the struct of letter should be {char:"",pinyin:""}
                                        var letter = this.props.overriddenLetters.letters[j];
                                        if ((letter.char === item && letter.pinyin === syllables[i] && !_.has(letter, "index")) || (_.has(letter, "index") && letter.index === i)) {
                                            // TODO: consider the index of special letter ?

                                            // The event here cannot be registered automatically.
                                            // Please register the corresponding event manually in the render method
                                            return this.props.overriddenLetters.renderOverriddenLetter(letter, i);
                                        }
                                    }
                                }
                                return (
                                    <Letter
                                        key={i}
                                        style={{ ...style, ...letterStyle, ...exstyle }}
                                        data={{
                                            char: item,
                                            pinyin: syllables[i],
                                        }}
                                        charVisible={this.props.charVisible}
                                        pinyinVisible={this.props.pinyinVisible}
                                        syllableStyle={{...this.props.syllableStyle, ...exstyle}}
                                        onPress={this._handleLetterPress.bind(this, {
                                            char: item,
                                            pinyin: syllables[i],
                                        })}
                                        forceLetterShowPinYinForEmptyChar={this.props.forceLetterShowPinYinForEmptyChar}
                                        enableLearnedColor={this.props.enableLearnedColor}
                                        enableLearnedPinyin={this.props.enableLearnedPinyin}
                                    />
                                );
                            })}
                    </View>
                </TouchableWithoutFeedback>
            </>
        );
    }
    _handlePress = word => {
        if (Helper.isPunctuation(word.chars.join(""))) {
            if(!this.props.clickPunctuation) return;
        }
        if (this.props.onPress) {
            this.props.onPress(word);
        } else {
            if (this.props.onPressing) {
                this.props.onPressing();
            }
            if(word.chars.length === 1){
                BottomPopExplanationInstance.handleLetterExplanationSheet({char: word.chars[0], pinyin: word.syllables[0]});
            }else{
                BottomPopExplanationInstance.handleWordExplanationSheet(word);
            }
        }
    };
    _handleLetterPress = data => {
        //过滤标点字符
        let { char } = data;
        if (Helper.isPunctuation(char)) {
            if(!this.props.clickPunctuation) return;
        }

        if (this.props.onLetterPress) {
            this.props.onLetterPress(data);
        } else {
            this._handlePress(this.props.data);
        }
    };
}

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        marginVertical: 4,
    },
    pinyin: {
        fontSize: 9.888,
        textAlign: "center",
        //fontFamily: customFontName
    },
    typo: {
        color: "#242424",
        lineHeight: 28,
        ...Platform.select({
            ios: {
                marginHorizontal: 1,
                marginTop: 8,
                fontSize: 15.6,
            },
            android: {
                marginHorizontal: 1,
                marginTop: 0.5,
                fontSize: 15.6,
            }
        }),
    },
    iconRight:{
        color:"#00CC33", position: "absolute", top: -2, right:-1
    },
    iconWrong:{
        color:"#FF3300",
        position: "absolute", top: -2, right:-1
    },
});

Word.propTypes = {
    data: PropTypes.object,
    style: PropTypes.object,
    letterStyle: PropTypes.object,
    syllableStyle: PropTypes.object,
    charProgress: PropTypes.number,
    progressColor: PropTypes.string,
    onPressing: PropTypes.func,
    onPress: PropTypes.func,
    onLetterPress: PropTypes.func,
    charVisible: PropTypes.bool,
    pinyinVisible: PropTypes.bool,
    overriddenLetters: PropTypes.object,
    renderOverriddenLetter: PropTypes.func,
    wrapLetters: PropTypes.bool,
    iconKind: PropTypes.string,
    clickPunctuation: PropTypes.bool,   //标点字符是否可以点击，默认不可以; POZF1单元需要可以点击
    enableLearnedColor: PropTypes.bool, //学习过的字是否变色
    enableLearnedPinyin: PropTypes.bool, //是否根据学习过字的等级来判断是否显示拼音
};

Word.defaultProps = {
    data: {
        syllables: [],
        chars: [],
    },
    language: 'zh',
    style: {},
    letterStyle: {},
    charProgress: 0,
    progressColor: '',
    onPressing: null,
    onPress: null,
    onLetterPress: null,
    charVisible: true, // if show Chinese character
    pinyinVisible: true, // if show piyin of chinese character
    overriddenLetters: { letters: [{}], renderOverriddenLetter: null }, // customize letters' display and control
    wrapLetters: false,
    iconKind: "",
    clickPunctuation: false,    //标点字符是否可以点击，默认不可以; POZF1单元需要可以点击
    enableLearnedColor: true, //学习过的字是否变色
    enableLearnedPinyin: true, //是否根据学习过字的等级来判断是否显示拼音
};

export default Word;
